import React from "react";
import { useState, useEffect, useRef } from "react";
import axios from "axios";
import defaultAvatar from "../images/download.jpg";
import Swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.css";
import Sidebar from "../layout/Sidebar";
import AgentSidebar from "../layout/AgentSidebar";

function Customers() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [items, setItems] = useState([]);
  const [isEditMode, setIsEditMode] = useState(false);
  const [agents, setAgents] = useState([]);
  const [fetched, setFetched] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [errors, setErrors] = useState({});
  const [isSubmitted, setIsSubmitted] = useState(false);
  const baseURL = process.env.REACT_APP_BASE_URL;
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [showCamera, setShowCamera] = useState(false);
  const [stream, setStream] = useState(null);
  const videoRef = useRef(null);
  const canvasRef = useRef(null);
  const [touched, setTouched] = useState({
    aadharno: false,
    areaname: false,

    contactno: false,
    statuss: false,
    address: false,
    cardno: false,
    tamilname: false,
    joining_date: false,
    admin_id: false,
    customername: false,
    alternativeno: false,
  });
  const [formData, setFormData] = useState({
    image: "",
    aadharno: "",
    areaname: "",
    alternativeno: "",
    contactno: "",
    statuss: "",
    address: "",
    cardno: "",
    tamilname: "",
    joining_date: "",
    admin_id: "",
    customername: "",
  });
  const role = sessionStorage.getItem("role");
  const SidebarComponent = role === "agent" ? AgentSidebar : Sidebar;

  const openCamera = async () => {
    setShowCamera(true);

    if (stream) {
      stream.getTracks().forEach((track) => track.stop());
      setStream(null);
    }

    try {
      const mediaStream = await navigator.mediaDevices.getUserMedia({
        video: { facingMode: "user" },
        audio: false,
      });

      if (videoRef.current) {
        videoRef.current.srcObject = mediaStream;

        videoRef.current.onloadedmetadata = () => {
          videoRef.current
            .play()
            .then(() => {
              console.log("Video is playing");
            })
            .catch((err) => {
              console.error("Error playing video:", err);
            });
        };
      }

      setStream(mediaStream);
    } catch (error) {
      console.error("Error accessing camera:", error);
      alert("Could not access the camera.");
    }
  };

  const closeCamera = () => {
    if (stream) {
      stream.getTracks().forEach((track) => track.stop());
      setStream(null);
    }

    if (videoRef.current) {
      videoRef.current.srcObject = null;
    }

    setShowCamera(false);
  };
  const captureImage = () => {
    const canvas = canvasRef.current;
    const video = videoRef.current;

    if (canvas && video) {
      const context = canvas.getContext("2d");
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
      context.drawImage(video, 0, 0, canvas.width, canvas.height);

      canvas.toBlob((blob) => {
        if (blob) {
          const timestamp = Date.now();
          const fileName = `customers_${timestamp}.jpg`;
          const imageFile = new File([blob], fileName, { type: "image/jpeg" });

          const imageUrl = URL.createObjectURL(imageFile);

          setSelectedImage(imageFile);

          setFormData((prev) => ({
            ...prev,
            image: fileName,
            imageURL: imageUrl,
          }));

          closeCamera();
        }
      }, "image/jpeg");
    }

    setShowCamera(false);
  };

  const handleDropdownClick = () => {
    const accessToken = sessionStorage.getItem("access_token");
    axios
      .get(`${baseURL}/getAllAdmin`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .then((response) => {
        setAgents(response.data);
        setFetched(true);
      })
      .catch((error) => console.error("Error fetching agents:", error));
  };

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
    if (!isModalOpen && !isEditMode) {
      setTouched({
        aadharno: false,
        areaname: false,
        contactno: false,
        statuss: false,
        address: false,
        cardno: false,
        tamilname: false,
        joining_date: false,
        admin_id: false,
        customername: false,
        alternativeno: false,
      });
      setFormData({
        image: "",
        aadharno: "",
        areaname: "",
        alternativeno: "",
        contactno: "",
        statuss: "",
        address: "",
        cardno: "",
        tamilname: "",
        joining_date: "",
        admin_id: "",
        customername: "",
      });
      setSelectedImage(null);
    }
  };

  const validateField = (name, value) => {
    let error = "";
    const contactno = formData.contactno;

    if (
      (name === "customername" ||
        name === "tamilname" ||
        name === "contactno") &&
      !value
    ) {
      error = "Required";
    }

    if (name === "tamilname" && value) {
      if (!/^[\u0B80-\u0BFF\s]+$/.test(value)) {
        error = "Name must only contain Tamil characters";
      }
    }

    if (name === "contactno" && value) {
      if (!/^\d{10}$/.test(value)) {
        error = "Contact number must be 10 digits";
      } else if (!/^[9|8|7|6]/.test(value)) {
        error = "Contact number must start with 9, 8, 7, or 6";
      }
    }

    if (name === "aadharno" && value) {
      if (!/^\d{4}-\d{4}-\d{4}$/.test(value)) {
        error = "Aadhar number must be in the format xxxx-xxxx-xxxx";
      }
    }

    if (name === "alternativeno" && value) {
      if (!/^\d{10}$/.test(value)) {
        error = "Contact number must be 10 digits";
      } else if (value === contactno) {
        error =
          "Alternative contact number cannot be the same as the contact number";
      }
    }

    if (name === "cardno" && value) {
      if (!/^\d{12}$/.test(value)) {
        error = "Card number must contain exactly 12 digits";
      }
    }

    return error;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    let formattedValue = value;

    if (name === "aadharno") {
      formattedValue = formattedValue.replace(/(\d{4})(?=\d)/g, "$1-");
    }

    setFormData((prevData) => ({
      ...prevData,
      [name]: formattedValue,
    }));

    setTouched((prevTouched) => ({
      ...prevTouched,
      [name]: true,
    }));

    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: validateField(name, formattedValue),
    }));
  };

  const updateData = async (id) => {
    const item = items.find((item) => item.id === id);
    console.log("Item : ", item);

    if (item) {
      let imageURL = null;

      if (item.image) {
        try {
          const accessToken = sessionStorage.getItem("access_token");
          const response = await axios.get(
            `${baseURL}/images/CustomerImages/${item.image}`,
            {
              headers: {
                Authorization: `Bearer ${accessToken}`,
              },
              responseType: "blob",
            }
          );
          imageURL = URL.createObjectURL(response.data);
        } catch (error) {
          console.error("Error fetching image:", error);
          imageURL = null;
        }
      }

      setFormData({
        id: item.id,
        imageURL: imageURL,
        image: item.image,
        aadharno: item.aadharno,
        customername: item.customername,
        cardno: item.cardno,
        contactno: item.contactno,
        statuss: item.statuss,
        address: item.address,
        tamilname: item.tamilname,
        areaname: item.areaname,
        joining_date: item.joining_date,
        alternativeno: item.alternativeno,
        admin_id: item.admin_id,
      });

      console.log("Populated formData for update:", formData);
      console.log("Updating data for customer", item);
      setIsEditMode(true);
      setSelectedImage(null);
      setIsModalOpen(true);
    }
  };

  const handleEdit = async () => {
    console.log("Form Data before update:", formData);

    const newErrors = {};
    for (const field in formData) {
      newErrors[field] = validateField(field, formData[field]);
    }

    if (Object.values(newErrors).some((error) => error)) {
      setErrors(newErrors);
      return;
    }
    let isAadharDuplicate = false;
    if (formData.aadharno) {
      isAadharDuplicate = items.some(
        (item) => item.aadharno === formData.aadharno && item.id !== formData.id
      );
    }

    if (isAadharDuplicate) {
      Swal.fire({
        icon: "error",
        text: "Aadhaar number already exists!",
        timer: 2000,
        showConfirmButton: false,
      });

      return;
    }

    const isContactNoDuplicate = items.some(
      (item) =>
        (item.contactno === formData.contactno ||
          item.alternativeno === formData.contactno) &&
        item.id !== formData.id
    );

    if (isContactNoDuplicate) {
      Swal.fire({
        icon: "error",
        text: "This contact number is already in use or is already set as an alternative number!",
        timer: 2000,
        showConfirmButton: false,
      });
      return;
    }

    let isAlternativeNoDuplicate = false;
    if (formData.alternativeno) {
      isAlternativeNoDuplicate = items.some(
        (item) =>
          (item.contactno === formData.alternativeno ||
            item.alternativeno === formData.alternativeno) &&
          item.id !== formData.id
      );
    }

    if (isAlternativeNoDuplicate) {
      Swal.fire({
        icon: "error",
        text: "This alternative contact number is already in use or is already set as a contact number!",
        timer: 2000,
        showConfirmButton: false,
      });
      return;
    }

    const data = new FormData();

    if (selectedImage) {
      data.append("image", selectedImage);
      console.log(selectedImage);
      console.log("Image appended:", selectedImage);
    }

    // Append all other form fields
    data.append("id", formData.id);
    data.append("customername", formData.customername);
    data.append("aadharno", formData.aadharno);
    data.append("cardno", formData.cardno);
    data.append("contactno", formData.contactno);
    data.append("tamilname", formData.tamilname);
    data.append("areaname", formData.areaname);
    data.append("statuss", formData.statuss);
    data.append("address", formData.address);
    data.append("joining_date", formData.joining_date);
    data.append("alternativeno", formData.alternativeno);
    data.append("admin_id", formData.admin_id);

    console.log("FormData entries:", Array.from(data.entries()));
    console.log("FormData being sent:", Array.from(data.entries()));

    try {
      const accessToken = sessionStorage.getItem("access_token");
      const response = await axios.put(`${baseURL}/updateCustomer`, data, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${accessToken}`,
        },
      });

      if (response.status === 200) {
        Swal.fire({
          icon: "success",
          text: "Customer updated successfully!",
          timer: 2000,
          showConfirmButton: false,
        });
        fetchItems();
        toggleModal();
        setIsEditMode(false);
      } else {
        console.error("Error updating Customer:", response.data);
      }
    } catch (error) {
      console.error("Error submitting form data:", error);
    }
  };

  const visiblePages = 5;

  const getPageNumbers = () => {
    const pages = [];
    if (totalPages <= visiblePages + 2) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      const startPage = Math.max(2, currentPage - Math.floor(visiblePages / 2));
      const endPage = Math.min(
        totalPages - 1,
        currentPage + Math.floor(visiblePages / 2)
      );

      pages.push(1);

      if (startPage > 2) pages.push("...");

      for (let i = startPage; i <= endPage; i++) {
        pages.push(i);
      }

      if (endPage < totalPages - 1) pages.push("...");

      pages.push(totalPages);
    }
    return pages;
  };

  const handleSubmit = async () => {
    setIsSubmitted(true);

    setTouched({
      aadharno: true,
      areaname: true,
      contactno: true,
      statuss: true,
      address: true,
      cardno: true,
      tamilname: true,
      joining_date: true,
      admin_id: true,
      customername: true,
      alternativeno: true,
    });
    const newErrors = {};
    for (const field in formData) {
      newErrors[field] = validateField(field, formData[field]);
    }

    if (Object.values(newErrors).some((error) => error)) {
      setErrors(newErrors);
      return;
    }
    console.log("Form Data Before Submission:", formData);
    let isAadharDuplicate = false;
    if (formData.aadharno) {
      isAadharDuplicate = items.some(
        (item) => item.aadharno === formData.aadharno
      );
    }
    if (isAadharDuplicate) {
      Swal.fire({
        icon: "error",
        text: "Aadhaar number already exists!",
        timer: 2000,
        showConfirmButton: false,
      });

      return;
    }

    const isContactNoDuplicate = items.some(
      (item) =>
        item.contactno === formData.contactno ||
        item.alternativeno === formData.contactno
    );

    if (isContactNoDuplicate) {
      Swal.fire({
        icon: "error",
        text: "This contact number already exists!",
        timer: 2000,
        showConfirmButton: false,
      });

      return;
    }

    let isAlternativeContactNoDuplicate = false;
    if (formData.alternativeno) {
      isAlternativeContactNoDuplicate = items.some(
        (item) =>
          item.contactno === formData.alternativeno ||
          item.alternativeno === formData.alternativeno
      );
    }

    if (isAlternativeContactNoDuplicate) {
      Swal.fire({
        icon: "error",
        text: "This alternative contact number already exists!",
        timer: 2000,
        showConfirmButton: false,
      });

      return;
    }

    const data = new FormData();

    if (selectedImage) {
      data.append("image", selectedImage);
      console.log("Selected Image:", selectedImage);
    } else {
      const response = await fetch(defaultAvatar);

      const blob = await response.blob();
      const defaultFile = new File([blob], "default-avatar.jpg", {
        type: blob.type,
      });
      data.append("image", defaultFile);
      console.log("Default Avatar Image:", defaultFile);
    }

    data.append("customername", formData.customername);
    data.append("aadharno", formData.aadharno);
    data.append("cardno", formData.cardno);
    data.append("contactno", formData.contactno);
    data.append("tamilname", formData.tamilname);
    data.append("areaname", formData.areaname);
    data.append("statuss", formData.statuss);
    data.append("address", formData.address);
    data.append("joining_date", formData.joining_date);
    data.append("alternativeno", formData.alternativeno);
    data.append("admin_id", formData.admin_id);

    try {
      const accessToken = sessionStorage.getItem("access_token");
      const response = await axios.post(`${baseURL}/insertCustomer`, data, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${accessToken}`,
        },
      });
      Swal.fire({
        icon: "success",
        text: "Customer added successfully!",
        timer: 2000,
        showConfirmButton: false,
      });

      toggleModal();
      fetchItems();
    } catch (error) {
      console.error("Error submitting form data:", error);
    }
  };

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setSelectedImage(file);
      setFormData({
        ...formData,
        image: file.name,
      });
    }
  };

  useEffect(() => {
    const role = sessionStorage.getItem("role");

    if (role === "agent") {
      fetchAgentItems();
    } else {
      fetchItems();
      handleDropdownClick();
    }
  }, []);

  const fetchAgentItems = async () => {
    setIsLoading(true);
    try {
      const accessToken = sessionStorage.getItem("access_token");
      const agentId = sessionStorage.getItem("agent_id");

      const response = await axios.get(`${baseURL}/getAgentCustomers`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
        params: {
          agent_id: agentId,
        },
      });

      const itemsWithImages = await Promise.all(
        response.data.map(async (item) => {
          if (item.image) {
            try {
              const imageResponse = await axios.get(
                `${baseURL}/images/CustomerImages/${item.image}`,
                {
                  headers: {
                    Authorization: `Bearer ${accessToken}`,
                  },
                  responseType: "blob",
                }
              );
              const imageURL = URL.createObjectURL(imageResponse.data);
              return { ...item, imageURL };
            } catch (imageError) {
              console.error("Error fetching image:", imageError);
              return { ...item, imageURL: null };
            }
          } else {
            return { ...item, imageURL: null };
          }
        })
      );

      setItems(itemsWithImages);
    } catch (error) {
      console.error("Error fetching items:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchItems = async () => {
    setIsLoading(true);
    try {
      const accessToken = sessionStorage.getItem("access_token");

      const response = await axios.get(`${baseURL}/getAllCustomer`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });

      const itemsWithImages = await Promise.all(
        response.data.map(async (item) => {
          if (item.image) {
            try {
              const imageResponse = await axios.get(
                `${baseURL}/images/CustomerImages/${item.image}`,
                {
                  headers: {
                    Authorization: `Bearer ${accessToken}`,
                  },
                  responseType: "blob",
                }
              );
              const imageURL = URL.createObjectURL(imageResponse.data);
              return { ...item, imageURL };
            } catch (imageError) {
              console.error("Error fetching image:", imageError);
              return { ...item, imageURL: null };
            }
          } else {
            return { ...item, imageURL: null };
          }
        })
      );

      setItems(itemsWithImages);
    } catch (error) {
      console.error("Error fetching items:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleDelete = (item) => {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you really want to delete this user?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        deleteItem(item.id);
        Swal.fire({
          icon: "success",
          title: "Deleted!",
          text: "The user has been deleted.",
          timer: 2000,
          showConfirmButton: false,
        });
      }
    });
  };

  useEffect(() => {
    if (isEditMode) {
      setSelectedImage(null);
    }
  }, [isEditMode]);

  const deleteItem = async (id) => {
    try {
      const accessToken = sessionStorage.getItem("access_token");
      const response = await axios.delete(`${baseURL}/deleteCustomer`, {
        data: { id: id },
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });

      if (response.status === 200) {
        fetchItems();
      } else {
        Swal.fire({
          icon: "error",
          title: "Deletion Failed",

          timer: 3000,
          showConfirmButton: false,
        });
      }
    } catch (error) {
      console.error("Error deleting item:", error);
    }
  };

  const filteredItems = items.filter(
    (item) =>
      item.customername.toLowerCase().includes(searchQuery.toLowerCase()) ||
      item.contactno.includes(searchQuery) ||
      item.aadharno.includes(searchQuery)
  );

  // Pagination Logic
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredItems.slice(indexOfFirstItem, indexOfLastItem);

  const totalPages = Math.ceil(filteredItems.length / itemsPerPage);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  return (
    <div className="bg-gray-100 flex flex-col w-full">
      <SidebarComponent />
      <main className="flex-grow p-6 w-full">
        <h2 className="text-3xl font-bold text-center mt-5">Customers</h2>

        {/* Table */}
        <div className="mt-6 bg-white shadow rounded-lg p-4 ml-0 sm:ml-0 md:ml-28 lg:ml-64">
          <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center space-y-4 sm:space-y-0 mb-4">
            <div className="flex items-center space-x-2">
              <label className="md:text-sm">Show</label>
              <select
                className="border border-gray-300 rounded p-1"
                onChange={(e) => setItemsPerPage(Number(e.target.value))}
                value={itemsPerPage}
              >
                <option className="md:text-xs" value="10">
                  10
                </option>
                <option className="md:text-xs" value="25">
                  25
                </option>
                <option className="md:text-xs" value="50">
                  50
                </option>
              </select>
              <span>entries</span>
            </div>

            <div className="flex items-center space-x-4 overflow-y-auto">
              {role !== "agent" && (
                <button
                  onClick={() => {
                    setIsEditMode(false);
                    toggleModal();
                  }}
                  className="bg-green-500 text-white px-4 py-2 rounded w-full sm:w-auto"
                >
                  Add Customer
                </button>
              )}

              {isModalOpen && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                  <div className="relative w-full sm:w-full md:w-1/2 max-h-[70vh] overflow-y-auto bg-white rounded-lg p-4 top-12 sm:top-16 md:top-24">
                    <div className="flex justify-between items-center mb-4">
                      <h2 className="text-lg md:text-xl font-semibold">
                        {isEditMode ? "Update Customer" : "Add Customer"}
                      </h2>
                      <button
                        onClick={() => {
                          setIsEditMode(false);
                          toggleModal();
                        }}
                        className="text-gray-600 text-2xl"
                      >
                        &times;
                      </button>
                    </div>
                    <form className="space-y-4">
                      <div className="flex flex-col items-center mb-6">
                        <label className="relative cursor-pointer">
                          <div className="w-20 h-20 sm:w-24 sm:h-24 rounded-full bg-gray-200 overflow-hidden flex items-center justify-center">
                            <img
                              src={
                                selectedImage
                                  ? URL.createObjectURL(selectedImage)
                                  : formData.imageURL
                                  ? formData.imageURL
                                  : defaultAvatar
                              }
                              alt="Profile Preview"
                              className="w-full h-full object-cover"
                            />
                          </div>
                          <input
                            type="file"
                            accept="image/*"
                            onChange={handleImageChange}
                            className="hidden"
                          />
                        </label>
                        <span className="text-sm text-gray-600 mt-2">
                          Photo
                        </span>
                      </div>
                      <div className="mt-2 flex flex-col items-center">
                        <button
                          type="button"
                          onClick={openCamera}
                          className="text-blue-500 underline text-sm"
                        >
                          Use Camera
                        </button>
                      </div>

                      {showCamera && (
                        <div className="my-4">
                          <video
                            ref={videoRef}
                            autoPlay
                            playsInline
                            className="w-full rounded shadow"
                          />
                          <canvas ref={canvasRef} className="hidden" />
                          <div className="flex justify-end space-x-2 mt-2">
                            <button
                              onClick={closeCamera}
                              type="button"
                              className="bg-red-500 text-white px-3 py-1 rounded"
                            >
                              Cancel
                            </button>
                            <button
                              onClick={captureImage}
                              type="button"
                              className="bg-green-500 text-white px-3 py-1 rounded"
                            >
                              Capture
                            </button>
                          </div>
                        </div>
                      )}
                      <div className="grid grid-cols-2 gap-4">
                        <div>
                          <label className="block text-gray-600">
                            Aadhar No
                          </label>
                          <input
                            type="text"
                            required
                            name="aadharno"
                            value={formData.aadharno || ""}
                            placeholder="Enter aadhar no. in xxxx-xxxx-xxxx format"
                            onChange={handleInputChange}
                            className={`border p-2 w-full placeholder:text-sm ${
                              errors.aadharno && touched.aadharno
                                ? "border-red-500"
                                : "border-gray-300"
                            }`}
                          />
                          {errors.aadharno && touched.aadharno && (
                            <span className="text-red-500 text-sm">
                              {errors.aadharno}
                            </span>
                          )}
                        </div>
                        <div>
                          <label className="block text-gray-600">
                            Customer Name<span className="text-red-500">*</span>
                          </label>
                          <input
                            type="text"
                            required
                            name="customername"
                            value={formData.customername || ""}
                            onChange={handleInputChange}
                            className={`border p-2 w-full   ${
                              errors.customername && touched.customername
                                ? "border-red-500"
                                : "border-gray-300"
                            }`}
                          />
                          {errors.customername && touched.customername && (
                            <span className="text-red-500 text-sm">
                              {errors.customername}
                            </span>
                          )}
                        </div>
                        <div>
                          <label className="block text-gray-600">
                            Area Name
                          </label>
                          <input
                            type="text"
                            required
                            name="areaname"
                            value={formData.areaname || ""}
                            onChange={handleInputChange}
                            className={`border p-2 w-full border-gray-300
                            `}
                          />
                        </div>

                        <div>
                          <label className="block text-gray-600">
                            Smart Card No
                          </label>
                          <input
                            type="text"
                            required
                            name="cardno"
                            value={formData.cardno || ""}
                            maxLength={12}
                            placeholder="Enter 12 digit smart card no"
                            onChange={handleInputChange}
                            className={`border p-2 w-full  placeholder:text-sm ${
                              errors.cardno && touched.cardno
                                ? "border-red-500"
                                : "border-gray-300"
                            }`}
                          />
                          {errors.cardno && touched.cardno && (
                            <span className="text-red-500 text-sm">
                              {errors.cardno}
                            </span>
                          )}
                        </div>
                        <div>
                          <label className="block text-gray-600">
                            Contact No<span className="text-red-500">*</span>
                          </label>
                          <input
                            type="text"
                            required
                            name="contactno"
                            value={formData.contactno || ""}
                            maxLength={10}
                            placeholder="Enter 10 digit mobile no."
                            onChange={handleInputChange}
                            /* onChange={(e) => setFormData({ ...formData, contactno: e.target.value })} */ className={`border  placeholder:text-sm p-2 w-full ${
                              errors.contactno && touched.contactno
                                ? "border-red-500"
                                : "border-gray-300"
                            }`}
                          />
                          {errors.contactno && touched.contactno && (
                            <span className="text-red-500 text-sm">
                              {errors.contactno}
                            </span>
                          )}
                        </div>
                        <div>
                          <label className="block text-gray-600">
                            Alternate Contact No
                          </label>
                          <input
                            type="text"
                            required
                            name="alternativeno"
                            value={formData.alternativeno || ""}
                            placeholder="Enter alternative 10 digit mobile number"
                            onChange={handleInputChange}
                            className={`border p-2 w-full  placeholder:text-sm ${
                              errors.alternativeno && touched.alternativeno
                                ? "border-red-500"
                                : "border-gray-300"
                            }`}
                          />
                          {errors.alternativeno && touched.alternativeno && (
                            <span className="text-red-500 text-sm">
                              {errors.alternativeno}
                            </span>
                          )}
                        </div>

                        <div>
                          <label className="block text-gray-600">
                            Tamil Name<span className="text-red-500">*</span>
                          </label>
                          <input
                            type="text"
                            name="tamilname"
                            value={formData.tamilname || ""}
                            placeholder="Enter customer's name in tamil"
                            onChange={handleInputChange}
                            className={`border p-2 w-full  placeholder:text-sm  ${
                              errors.tamilname && touched.tamilname
                                ? "border-red-500"
                                : "border-gray-300"
                            }`}
                          />
                          {errors.tamilname && touched.tamilname && (
                            <span className="text-red-500 text-sm">
                              {errors.tamilname}
                            </span>
                          )}
                        </div>
                        <div>
                          <label className="block text-gray-600">
                            Joining date
                          </label>
                          <input
                            type="date"
                            name="joining_date"
                            value={formData.joining_date || ""}
                            onChange={handleInputChange}
                            className={`border p-2 w-full border-gray-300
                            `}
                          />
                        </div>

                        {isEditMode && (
                          <div>
                            <label className="block text-gray-600">
                              Status
                            </label>
                            <select
                              name="statuss"
                              value={formData.statuss || ""}
                              onChange={handleInputChange}
                              className="border p-2 w-full border-gray-300"
                            >
                              <option>Mark the status</option>
                              <option>Active</option>
                              <option>Inactive</option>
                            </select>
                          </div>
                        )}

                        <div>
                          <label className="block text-gray-600">Agent</label>
                          <select
                            name="admin_id"
                            value={formData.admin_id || ""}
                            onClick={handleDropdownClick}
                            onChange={handleInputChange}
                            className={`border p-2 w-full border-gray-300
                            `}
                          >
                            <option value="">Select Agent</option>
                            {agents.length > 0 ? (
                              agents.map((agent) => (
                                <option key={agent.id} value={agent.id}>
                                  {agent.name}
                                </option>
                              ))
                            ) : (
                              <option disabled>No agents available</option>
                            )}
                          </select>
                        </div>
                      </div>

                      <div>
                        <label className="block text-gray-600">Address</label>
                        <textarea
                          name="address"
                          value={formData.address || ""}
                          onChange={handleInputChange}
                          className={`border p-2 w-full `}
                          rows="3"
                        ></textarea>
                      </div>
                      <div className="flex justify-end space-x-2 mt-4">
                        <button
                          type="button"
                          onClick={() => {
                            toggleModal();
                            setIsEditMode(false);
                          }}
                          className="bg-gray-300 text-gray-700 px-4 py-2 rounded hover:bg-gray-400"
                        >
                          Close
                        </button>
                        <button
                          onClick={() => {
                            if (isEditMode) {
                              handleEdit();
                            } else {
                              handleSubmit();
                              setIsEditMode(false);
                            }
                          }}
                          type="button"
                          className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
                        >
                          {isEditMode ? "Update" : "Submit"}
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              )}
              <div className="flex items-center space-x-2">
                <input
                  type="text"
                  placeholder="Search"
                  className="border border-gray-300 rounded p-1  w-full sm:w-auto"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                />
              </div>
            </div>
          </div>
          <div className="flex flex-col h-screen">
            <div className="overflow-x-auto">
              {/* Table Content */}
              <table className="w-full text-left border-collapse">
                <thead>
                  <tr className="bg-gray-200">
                    <th className="p-2">Id</th>
                    <th className="p-2">Photo</th>
                    <th className="p-1">Customer Name</th>
                    <th className="p-1">Tamil Name</th>
                    <th className="p-1">Contact No.</th>
                    <th className="p-2">Status</th>
                    {role !== "agent" && <th className="p-2">Options</th>}
                  </tr>
                </thead>
                <tbody>
                  {isLoading ? (
                    <tr>
                      <td
                        colSpan={role !== "agent" ? 7 : 6}
                        className="text-center p-4"
                      >
                        Loading...
                      </td>
                    </tr>
                  ) : (
                    currentItems.map((item) => (
                      <tr key={item.id} className="border-b">
                        <td className="p-2">{item.id}</td>
                        <td className="p-2">
                          <img
                            src={item.imageURL ? item.imageURL : defaultAvatar}
                            alt="User Avatar"
                            className="w-8 h-8 rounded-full"
                          />
                        </td>
                        <td className="p-1">{item.customername || "--"}</td>
                        <td className="p-1">{item.tamilname || "--"}</td>
                        <td className="p-1">{item.contactno || "--"}</td>
                        <td className="p-2">{item.statuss || "--"}</td>
                        {role !== "agent" && (
                          <td className="p-2 space-x-3">
                            <button
                              onClick={() => updateData(item.id)}
                              className="text-blue-500"
                            >
                              <i className="fas fa-edit"></i>
                            </button>
                            <button
                              onClick={() => handleDelete(item)}
                              className="text-red-500"
                            >
                              <i className="fas fa-trash"></i>
                            </button>
                          </td>
                        )}
                      </tr>
                    ))
                  )}
                </tbody>
              </table>

              <div className="flex justify-between items-center mt-4">
                <p>
                  Showing {indexOfFirstItem + 1} to{" "}
                  {indexOfLastItem > items.length
                    ? items.length
                    : indexOfLastItem}{" "}
                  of {items.length} entries
                </p>

                <div className="flex space-x-1 overflow-x-auto">
                  <button
                    className="border px-2 py-1 rounded"
                    disabled={currentPage === 1}
                    onClick={() => handlePageChange(currentPage - 1)}
                  >
                    Previous
                  </button>

                  {getPageNumbers().map((page, idx) =>
                    page === "..." ? (
                      <span key={idx} className="px-2">
                        …
                      </span>
                    ) : (
                      <button
                        key={idx}
                        className={`border px-2 py-1 rounded ${
                          currentPage === page ? "bg-blue-500 text-white" : ""
                        }`}
                        onClick={() => handlePageChange(page)}
                      >
                        {page}
                      </button>
                    )
                  )}

                  <button
                    className="border px-2 py-1 rounded"
                    disabled={currentPage === totalPages}
                    onClick={() => handlePageChange(currentPage + 1)}
                  >
                    Next
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}
export default Customers;
